import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Icon } from "@/components/Icon";
import { Reveal } from "@/components/Reveal";

export function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    // Never present sample/development reviews as genuine on the live site.
    api.get("/testimonials")
      .then((r) => setItems((r.data || []).filter((t) => !t.is_sample)))
      .catch(() => setItems([]));
  }, []);

  return (
    <section className="bg-brand-bg py-20 sm:py-28" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <p className="eyebrow text-brand-purple">Testimonials</p>
          <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            What Our Clients Say
          </h2>
        </div>

        {items.length === 0 ? (
          <div className="mx-auto mt-12 max-w-2xl rounded-3xl border border-slate-200 bg-white p-10 text-center shadow-sm" data-testid="testimonials-empty">
            <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-purple/10 text-brand-purple">
              <Icon name="ChatCircleText" size={28} weight="duotone" />
            </span>
            <h3 className="mt-5 font-heading text-xl font-semibold text-slate-900">Reviews Coming Soon</h3>
            <p className="mt-2 text-slate-600">
              We're gathering feedback from the individuals, families, and partners we proudly serve. Check back soon.
            </p>
          </div>
        ) : (
          <div className="mt-14 flex snap-x snap-mandatory gap-6 overflow-x-auto pb-4 [-ms-overflow-style:none] [scrollbar-width:none] md:grid md:grid-cols-3 md:overflow-visible md:pb-0"
            style={{ scrollbarWidth: "none" }}>
            {items.slice(0, 9).map((t, i) => (
              <Reveal key={t.id} delay={i * 0.08} className="min-w-[85%] snap-center sm:min-w-[60%] md:min-w-0">
                <figure data-testid={`testimonial-${t.id}`}
                  className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-7 shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl">
                  <Icon name="ChatCircleText" size={30} weight="fill" className="text-brand-purple/20" />
                  <div className="mt-3 flex gap-1 text-amber-400">
                    {Array.from({ length: 5 }).map((_, s) => (
                      <Icon key={s} name="Star" size={18} weight={s < (t.rating || 5) ? "fill" : "regular"} />
                    ))}
                  </div>
                  <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-slate-700">"{t.text}"</blockquote>
                  <figcaption className="mt-6 flex items-center gap-3 border-t border-slate-100 pt-5">
                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-brand-blue font-heading text-sm font-bold text-white">
                      {(t.author || "?").trim().charAt(0).toUpperCase()}
                    </span>
                    <span>
                      <span className="block font-semibold text-slate-900">{t.author}</span>
                      {t.location && <span className="text-sm text-slate-500">{t.location}</span>}
                    </span>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
